import React, { useState, useMemo } from "react";

import localization from "assets/localization/localization";
import DropDownInput from "../Input/dropDownInput/dropDownInput";
import ConstantInput from "../Input/constantInput/constantInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const TagOrdersFilter = ({
  showFilter,
  applyFilter,
  listFilterData = null,
}) => {

    const [isFocus, setIsFocus] = useState(false);
    const [isFocus2, setIsFocus2] = useState(false);

    const storageKey = "tag_orders_filter";

    const savedFilter = JSON.parse(window.localStorage.getItem(storageKey) || "{}");
    const [filterFieldsData, setFilterFieldsData] = useState({
        date_from: savedFilter?.date_from || "",
        date_to: savedFilter?.date_to || "",
        operator_phone_number: savedFilter?.operator_phone_number || "",
        acquirer: Array.isArray(savedFilter?.acquirer) ? savedFilter.acquirer : [],
        operator_role: Array.isArray(savedFilter?.operator_role) ? savedFilter.operator_role : [],
        fulfilment_status: Array.isArray(savedFilter?.fulfilment_status) ? savedFilter.fulfilment_status : [],
        operator_id: savedFilter?.operator_id || "",
        order_id: savedFilter?.order_id || "",
    });

    const bankOptions = useMemo(() => {
        return listFilterData?.filter_fields?.find(f => f.filter_name === "acquirer")?.filter_data?.map(d => ({ id: d.value, name: d.text })) || [];
    }, [listFilterData]);

    const roleOptions = useMemo(() => {
        return listFilterData?.filter_fields?.find(f => f.filter_name === "operator_role")?.filter_data?.map(d => ({ id: d.value, name: d.text })) || [];
    }, [listFilterData]);

    const statusOptions = useMemo(() => {
        return listFilterData?.filter_fields?.find(f => f.filter_name === "fulfilment_status")?.filter_data?.map(d => ({ id: d.value, name: d.text })) || [];
    }, [listFilterData]);
    
    const handleDateChange = (jsdate, dateString) => {
        setFilterFieldsData({
        ...filterFieldsData,
        date_from: dateString,
        });
    };

    const handleDateChange2 = (jsdate, dateString) => {
        setFilterFieldsData({
        ...filterFieldsData,
        date_to: dateString,
        });
    };

    const handleDateHide = () => {
        if (!filterFieldsData.date_from) {
        setIsFocus(true);
        }
    };

    const handleDateHide2 = () => {
        if (!filterFieldsData.date_to) {
        setIsFocus2(true);
        }
    };

  const role_id = localStorage.getItem("fusion-role");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(storageKey, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >

      <DropDownInput
        label='Status'
        data={statusOptions}
        getValueById={filterFieldsData.fulfilment_status?.[0] || ""}
        controlledValue={filterFieldsData.fulfilment_status?.length === 0 ? null : undefined}
        getIdValue={(val) => {
          if (val && val.id) {
            setFilterFieldsData({ ...filterFieldsData, fulfilment_status: [val.id] });
          } else {
            setFilterFieldsData({ ...filterFieldsData, fulfilment_status: [] });
          }
        }}
      />

      <h4 className="mb-2">{localization.fromDate}</h4>
      
      <FormGroup className={`date custom_date_picker ${isFocus ? "active-date" : ""}`}>

            <DatePickerInput
                onChange={handleDateChange}
                value={filterFieldsData.date_from}
                autoClose
                onShow={() => setIsFocus(true)}
                onHide={handleDateHide}
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                displayFormat="DD-MM-YYYY"
                returnFormat="YYYY-MM-DD"
                maxDate={new Date()}
            />

        </FormGroup>

        <h4 className="mb-2">{localization.toDate}</h4>

        <FormGroup className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}>

            <DatePickerInput
                onChange={handleDateChange2}
                value={filterFieldsData.date_to}
                autoClose
                onShow={() => setIsFocus2(true)}
                onHide={handleDateHide2}
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                displayFormat="DD-MM-YYYY"
                returnFormat="YYYY-MM-DD"
                maxDate={new Date()}
                disabled={!filterFieldsData.date_from}
            />

        </FormGroup>

      <DropDownInput
        label='Bank'
        data={bankOptions}
        getValueById={filterFieldsData.acquirer?.[0] || ""}
        controlledValue={filterFieldsData.acquirer?.length === 0 ? null : undefined}
        getIdValue={(val) => {
          if (val && val.id) {
            setFilterFieldsData({ ...filterFieldsData, acquirer: [val.id] });
          } else {
            setFilterFieldsData({ ...filterFieldsData, acquirer: [] });
          }
        }}
      />

      <DropDownInput
        label='Role'
        data={roleOptions}
        getValueById={filterFieldsData.operator_role?.[0] || ""}
        controlledValue={filterFieldsData.operator_role?.length === 0 ? null : undefined}
        getIdValue={(val) => {
          if (val && val.id) {
            setFilterFieldsData({ ...filterFieldsData, operator_role: [val.id] });
          } else {
            setFilterFieldsData({ ...filterFieldsData, operator_role: [] });
          }
        }}
      />

      <ConstantInput
        label="Operator Phone Number"
        value={filterFieldsData.operator_phone_number}
        type="number"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, operator_phone_number: val })
        }
      />

      <ConstantInput
        label="Operator ID"
        value={filterFieldsData.operator_id}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, operator_id: val })
        }
      />

      <ConstantInput
        label="Order ID"
        value={filterFieldsData.order_id}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, order_id: val })
        }
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>

        <br />
        <br />

        <button
          onClick={() => {
            window.localStorage.removeItem(storageKey);
            setFilterFieldsData({
                date_from: "",
                date_to: "",
                operator_phone_number: "",
                acquirer: [],
                operator_role: [],
                fulfilment_status: [],
                operator_id: "",
                order_id: "",
            });
            applyFilter({
                date_from: "",
                date_to: "",
                operator_phone_number: "",
                acquirer: [],
                operator_role: [],
                fulfilment_status: [],
                operator_id: "",
                order_id: "",
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default TagOrdersFilter;